export default "__VITE_ASSET__WQHRMiUG__"